import { Box, Button } from "@mui/material";
import StyledDialog from "../../../components/StyledDialog";
import { DisclosureHost } from "../../../hooks/use-disclosure";
import Flex from "../../../components/Flex";
import Text from "../../../components/Text";

interface NoShowProps {
  disclosureHost: DisclosureHost;
  onConfirm: () => void;
  onCancel: () => void;
}

export const NoShowConfirmation = ({
  disclosureHost,
  onConfirm,
  onCancel,
}: NoShowProps) => {
  return (
    <StyledDialog
      open={disclosureHost.opened}
      onClose={disclosureHost.close}
      dialogTitle="No Show"
      dialogAction={
        <Flex gap={1}>
          <Button variant="text" onClick={onCancel} autoFocus>
            No
          </Button>
          <Button variant="contained" onClick={onConfirm} autoFocus>
            Yes
          </Button>
        </Flex>
      }
    >
      <Box width={"20vw"} height={"5vh"}>
        <Text>
          The patient did not join the call. Are you sure to change the status
          to No Show and exit
        </Text>
      </Box>
    </StyledDialog>
  );
};
